//my groups link to summary card and quick action button

import { useNavigate} from "react-router-dom";
import api from "../../../Api/api";
import { useState, useEffect } from "react";

function DiningGroups() {
  const navigate = useNavigate();
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    if (!currentUser) return;

    //get the groups from api
    api.get("/dashboard/groups")
    .then((res) => {
      //const myGroups = res.data.groups.filter(groups => groups.createdBy === currentUser.email);
      setGroups(res.data.groups);
    })
    .catch((err) => console.error("Failed to load groups:", err));
}, []);

//handle the view group
const handleViewGroup = (groupId) => {
  navigate(`/group/${groupId}`);
};


  return (
    <div className="dashboard-card">
      <h5 className="mb-3">👥 My Groups</h5>
      {groups.length === 0 ? (
        <p className="text-muted">No groups created yet.</p>
      ) : (
        <ul className="list-group list-group-flush">
          {groups.map((group) => (
            <li
              key={group.id}
              className="list-group-item d-flex align-items-center justify-content-between"
            >
              <div className="d-flex align-items-center">
                <span style={{ fontSize: "1.5rem", marginRight: 12 }}>👥</span>
                <div>
                  <div className="fw-bold">{group.name}</div>
                </div>
              </div>
              <button
                className="btn btn-outline-secondary btn-sm"
                onClick={() => handleViewGroup(group.id)}
              >
                View
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default DiningGroups;